import striptags from 'striptags'

export function replaceBlockTags(html: string): string {
  const onlyBlock = striptags(html, ['p', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'br'], '')
  const stripped = striptags(onlyBlock, [], '\n')
  const replaceDoubleBreaks = stripped.replace(/\n\n/g, '\n').replace(/&nbsp;/g, ' ')
  return replaceDoubleBreaks.trim()
}
